import React, { useState, useEffect } from "react";
import axios from "axios";
import { ChevronDown, ShoppingBag, MapPin, Plus, AlertCircle, Check, ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import NavigationWithNoUnderlines from "./mealListNavigation";

const ProductSummary = () => {
  const [cartData, setCartData] = useState(null);
  // Removed unused state variable: expanded
  const [coolBag, setCoolBag] = useState(true);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [loading, setLoading] = useState(true);
  // Removed unused state variables: menuOpen, currentPackageIndex
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(0);
  const [showAddressSelector, setShowAddressSelector] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [isNewOrder, setIsNewOrder] = useState(false);
  const [currentDayIndex, setCurrentDayIndex] = useState(0);
  const navigate = useNavigate();

  // Helper function to safely format currency values
  const formatCurrency = (value) => {
    return typeof value === 'number' ? value.toFixed(2) : '0.00';
  };

  // Removed unused formatAddress function

  // After setting cartData from the API response, restructure it for your component
  useEffect(() => {
    const fetchCart = async () => {
      setLoading(true);
      try {
        const response = await axios.get("https://api.dailyfit.ae/api/user/get-cart", {
          withCredentials: true,
        });
        

        if (response.data && response.data.data) {
          const apiData = response.data.data;
          console.log(apiData, "The data in the api")

          const restructuredData = {
            meals: (apiData.cart?.package?.selectedMeals || []).map(dateItem => ({
              date: dateItem.date, // preserve the selected date
              packageName: apiData.cart?.package?.packageName || "Your Package",
              description: apiData.cart?.package?.description || "Your package description",
              fareTotalPerDay: (apiData.fareDetails?.mealsTotalPrice || 0) /
                (apiData.cart?.package?.selectedMeals?.length || 1),
              meals: (dateItem.meals || []).map(meal => ({
                ...meal,
                mealName: meal.mealName || "Unnamed Meal",
                description: meal.description || "",
                mealType: meal.mealType
                  ? [meal.mealType]
                  : [],
                image: meal.image || [],
                moreDetails: {
                  energy: meal.moreDetails?.energy || 0,
                  protein: meal.moreDetails?.protein || 0,
                  carbohydrates: meal.moreDetails?.carbohydrates || 0,
                  fat: meal.moreDetails?.fat || 0,
                  allergens: meal.moreDetails?.allergens || []
                },
                fareDetails: {
                  totalFare: meal.fareDetails?.totalFare || 0,
                  discount: meal.fareDetails?.discount || 0,
                  strikeOff: meal.fareDetails?.strikeOff || 0
                }
              }))
            })),
            addons: apiData.addons.map(addon => ({
              name: addon.mealName,
              pricePerDay: addon.fareDetails?.totalFare || 0,
              image: addon.image?.[0] || "/api/placeholder/48/48"
            })),
            fareDetails: {
              mealsTotalPrice: apiData.fareDetails?.mealsTotalPrice || 0,
              totalFare: apiData.fareDetails?.totalFare || 0,
              addOnsTotalPrice: apiData.fareDetails?.addOnsTotalPrice || 0
            }
          };

          setCartData(restructuredData);
          // Automatically select all add-ons
          setSelectedAddOns(restructuredData.addons);
          console.log(restructuredData.addons, "The addon data ")
        }
      } catch (error) {
        console.error("Error fetching cart:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCart();
  }, []);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setLoading(true);
        const response = await axios.get('https://api.dailyfit.ae/api/user/get-profile', { withCredentials: true });
        setProfileData(response.data.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching profile:", err);
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  useEffect(() => {
    const fetchFirstOrder = async () => {
      try {
        setLoading(true);
        const response = await axios.get('https://api.dailyfit.ae/api/user/is-firstOrder', { withCredentials: true });
        setIsNewOrder(response.data.data?.isNewOrder || false);
        setLoading(false);
      } catch (err) {
        console.error("Error checking first order:", err);
        setLoading(false);
      }
    };

    fetchFirstOrder();
  }, []);

  // Removed unused functions: toggleExpand and navigatePackage

  const toggleAddressSelector = () => {
    setShowAddressSelector(prev => !prev);
  };

  const selectAddress = (index) => {
    setSelectedAddressIndex(index);
    setShowAddressSelector(false);
  };

  const goToPreviousDay = () => {
    setCurrentDayIndex(prev => Math.max(0, prev - 1));
  };

  const goToNextDay = () => {
    setCurrentDayIndex(prev => Math.min(groupedMealsByDate.length - 1, prev + 1));
  };

  const goToDay = (index) => {
    setCurrentDayIndex(index);
  };

  const handleCompleteOrder = async () => {
    try {
      const orderStage = sessionStorage.getItem("userType");
      
      // If orderStage is not '1', navigate to the order page and return early
      if (orderStage !== "1") {
        navigate("/Order");
        return;
      }

      // Get the currently selected address from profileData
      const selectedAddress = profileData?.savedAddress?.[selectedAddressIndex];
      
      // Prepare order payload with the exact required structure
      const orderPayload = {
        address: {
          buildingName: selectedAddress?.buildingName || null,
          flatNumber: selectedAddress?.flatNumber || null,
          streetName: selectedAddress?.streetName || null,
          city: selectedAddress?.city || null,
          phoneNumber: selectedAddress?.phoneNumber || null,
          identifier: selectedAddress?.identifier || null,
          landmark: selectedAddress?.landmark || null,
          latitude: selectedAddress?.latitude, // Not available in current data
          longitude: selectedAddress.longitude, // Not available in current data
          addressType: selectedAddress?.addressType || 'home'
        },
        bagIncluded: coolBag,
      };

    // 1️⃣ CREATE ORDER
    console.log(orderPayload, "The order payload")


    const orderRes = await axios.post(
      "https://api.dailyfit.ae/api/user/createOrder",
      orderPayload,
      { withCredentials: true }
    );

    const orderData = orderRes.data;
    if (!orderData.status || !orderData.data?.orderID) {
      throw new Error(orderData.message || "Failed to create order");
    }

    const orderId = orderData.data.orderID;
    console.log("✅ Order Created:", orderId);

    // 2️⃣ CREATE PAYMENT SESSION
    const paymentRes = await axios.post(
      "https://api.dailyfit.ae/api/user/unified/create-payment",
      {
        orderId: orderId,
      },
      { withCredentials: true }
    );

    console.log(paymentRes, 'paymentRes');
    const paymentData = paymentRes.data;
    
    if (!paymentData.status || !paymentData.data?.paymentLink) {
      throw new Error(paymentData.message || "Failed to create payment session");
    }

    console.log("✅ Payment Session Created:", paymentData.data.paymentId);

    // 3️⃣ OPEN PAYMENT PAGE WITH ENHANCED WINDOW MANAGEMENT
    const paymentUrl = paymentData.data.paymentLink;
    
    // Open payment window with optimized settings
    const newWindow = window.open(
      paymentUrl,
      '_blank',
      'width=800,height=600,scrollbars=yes,resizable=yes,noopener,noreferrer,toolbar=no,menubar=no,status=no'
    );

    // Enhanced popup blocking detection and handling
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      // Popup was blocked, provide user-friendly fallback
      const shouldRedirect = window.confirm(
        "Your browser blocked the payment window. Would you like to open the payment page in a new tab instead?"
      );
      
      if (shouldRedirect) {
        // Try to open in new tab as fallback
        const fallbackWindow = window.open(paymentUrl, '_blank');
        
        // If even new tab is blocked, redirect current window
        if (!fallbackWindow) {
          const confirmRedirect = window.confirm(
            "Unable to open in new tab. Redirect to payment page in current window?"
          );
          if (confirmRedirect) {
            window.location.href = paymentUrl;
          }
        }
      }
    } else {
      // Window opened successfully, set up monitoring (optional)
      const checkWindow = setInterval(() => {
        if (newWindow.closed) {
          clearInterval(checkWindow);
          console.log("Payment window closed by user");
          // Optional: Check payment status or refresh page
          // You could add logic here to verify if payment was completed
        }
      }, 1000);

      // Clean up interval after 30 minutes to prevent memory leaks
      setTimeout(() => {
        clearInterval(checkWindow);
      }, 30 * 60 * 1000);
    }

    // Store order details for later reference
    sessionStorage.setItem("orderId", orderId);
    sessionStorage.setItem("paymentId", paymentData.data.paymentId);
    
    // Optional: Store timestamp for payment timeout handling
    sessionStorage.setItem("paymentStartTime", Date.now().toString());

    console.log("✅ Payment process initiated successfully");

  } catch (error) {
    console.error("Error processing order:", error);
    
    // More specific error handling
    if (error.response) {
      // Server responded with error status
      const errorMessage = error.response.data?.message || "Server error occurred";
      alert(`Error: ${errorMessage}`);
    } else if (error.request) {
      // Request was made but no response received
      alert("Network error. Please check your internet connection and try again.");
    } else {
      // Something else happened
      alert("An unexpected error occurred. Please try again.");
    }
  }
};
  //   const handleCompleteOrder = async () => {
  //     try {

  if (loading) {
    return (
      <div className="max-w-2xl mx-auto p-6 bg-white shadow-lg rounded-2xl mt-5 flex flex-col items-center justify-center h-64">
        <div className="w-12 h-12 border-4 border-t-green-500 border-green-200 rounded-full animate-spin"></div>
        <p className="text-gray-500 mt-4 font-medium">Loading your meal details...</p>
      </div>
    );
  }

  if (!cartData) {
    return (
      <div className="max-w-2xl mx-auto p-6 bg-white shadow-lg rounded-2xl mt-5 flex flex-col items-center justify-center h-64">
        <AlertCircle className="w-12 h-12 text-amber-500" />
        <p className="text-gray-700 mt-4 font-medium">Unable to load cart details. Please try again.</p>
      </div>
    );
  }

  // Extract cart details with safe defaults
  const { meals = [], fareDetails = { mealsTotalPrice: 0, totalFare: 0 }, mealTypeDetails = [] } = cartData;
  
  // Function to get meal name by identifier from mealTypeDetails
const getMealNameByIdentifier = (identifier, meal = null) => {
  // If identifier is an array → use the first value
  if (Array.isArray(identifier)) {
    identifier = identifier[0];
  }

  // Use the specific meal's mealTypeDetails if provided, otherwise fall back to first meal
  const mealTypeDetails = meal?.mealTypeDetails || cartData?.meals?.[0]?.meals?.[0]?.mealTypeDetails;

  console.log("Meal Type Details:", mealTypeDetails);
  console.log("Looking for:", identifier);

  if (Array.isArray(mealTypeDetails)) {
    const found = mealTypeDetails.find(
      (detail) => detail.identifier === identifier
    );

    if (found?.mealType) {
      return found.mealType;
    }
  }

  return identifier || "Other";
};


  
  console.log('Testing getMealNameByIdentifier function:');
  console.log('A7paj ->', getMealNameByIdentifier('A7paj'));

  // Group meals by mealType for each date
  console.log('Raw cartData.meals:', cartData?.meals);
  
  const groupedMealsByDate = (cartData?.meals || []).map((dateObj, dateIdx) => {
    console.log(`\n--- Processing dateObj[${dateIdx}] ---`);
    console.log('Date:', dateObj.date);
    console.log('Meals:', dateObj.meals);
    console.log('MealTypeDetails:', dateObj.mealTypeDetails);
    
    const typeGroups = {};
    
    for (const [mealIdx, meal] of (dateObj.meals || []).entries()) {
      console.log(`  Meal[${mealIdx}]:`, meal);
      let typeLabel = 'Other';
      let identifier = 'N/A';
      
      if (Array.isArray(meal.mealType) && meal.mealType.length > 0) {
        // Get the first meal type identifier
        const firstIdentifier = meal.mealType[0];
        identifier = firstIdentifier;
        
        // Use the function to get meal name
        typeLabel = getMealNameByIdentifier(firstIdentifier, meal);
        
        console.log(`    First identifier: ${firstIdentifier}, Type label: ${typeLabel}`);
      }
      
      const key = `${typeLabel}`;
      if (!typeGroups[key]) {
        typeGroups[key] = { typeLabel, identifier, meals: [] };
        console.log(`    New typeGroup: ${key}`);
      }
      typeGroups[key].meals.push(meal);
      console.log(`    Added to typeGroup ${key}`);
    }
    
    const result = {
      date: dateObj.date,
      typeGroups: Object.values(typeGroups),
    };
    console.log('Result for date:', result);
    return result;
  });
  console.log('\nFinal groupedMealsByDate:', groupedMealsByDate);

  return (
    <>
      <NavigationWithNoUnderlines />
      <div className="max-w-2xl mx-auto p-6 bg-gradient-to-b from-white to-gray-50 shadow-xl rounded-2xl mt-5 border border-gray-100">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800 flex items-center">
            <ShoppingBag className="w-6 h-6 mr-2 text-green-600" />
            Your Meal Package
          </h2>
          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
            {groupedMealsByDate.length} {groupedMealsByDate.length === 1 ? "day" : "days"}
          </span>
        </div>

        {/* Carousel for meals by day */}
        {groupedMealsByDate.length > 0 ? (
          <div className="relative">
            {/* Carousel Navigation */}
            <div className="flex items-center justify-between mb-4">
              <button
                onClick={goToPreviousDay}
                disabled={currentDayIndex === 0}
                className="p-2 rounded-full bg-white shadow-md border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                <ChevronLeft className="w-5 h-5 text-gray-600" />
              </button>
              
              <div className="text-center">
                <h3 className="text-lg font-bold text-gray-800">
                  {groupedMealsByDate[currentDayIndex]?.date && !isNaN(Date.parse(groupedMealsByDate[currentDayIndex]?.date))
                    ? new Date(groupedMealsByDate[currentDayIndex].date).toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" })
                    : (typeof groupedMealsByDate[currentDayIndex]?.date === 'string' ? groupedMealsByDate[currentDayIndex].date : `Day ${currentDayIndex + 1}`)}
                </h3>
                <div className="flex justify-center gap-1 mt-2">
                  {groupedMealsByDate.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToDay(index)}
                      className={`w-2 h-2 rounded-full transition-colors ${
                        index === currentDayIndex ? 'bg-green-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
              
              <button
                onClick={goToNextDay}
                disabled={currentDayIndex === groupedMealsByDate.length - 1}
                className="p-2 rounded-full bg-white shadow-md border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                <ChevronRight className="w-5 h-5 text-gray-600" />
              </button>
            </div>

            {/* Current Day's Meals */}
            <div className="bg-white rounded-xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 shadow-md border border-gray-100 p-4">
              {groupedMealsByDate[currentDayIndex]?.typeGroups.map((group) => (
                <div key={group.typeLabel + '_' + group.identifier} className="mb-4">
                  <h4 className="text-sm font-semibold text-emerald-700 mb-2">
                    {getMealNameByIdentifier(group.typeLabel, group.meals[0])}
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                    {group.meals.map((meal) => (
                      <div key={meal._id + '_' + group.identifier} className="flex items-center gap-3 bg-gray-50 rounded-lg p-3 lg:w-[calc(50%-0.5rem)]">
                        <div className="w-16 h-16 rounded-lg overflow-hidden bg-gray-200 flex-shrink-0">
                          <img src={meal.image} alt={meal.mealName} className="w-full h-full object-cover" />
                        </div>
                        <div className="flex-1">
                          <div className="font-bold text-xs text-gray-800">{meal.mealName}</div>
                          <div className="text-sm text-gray-600">{meal.description}</div>
                          <div className="mt-1 flex flex-wrap gap-2">
                            <span className="bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded text-xs font-semibold">
                              {getMealNameByIdentifier(group.typeLabel, meal)}
                            </span>
                          </div>
                          <div className="mt-2 flex items-center gap-2">
                            <span className="text-sm font-semibold text-gray-800">
                              AED{formatCurrency(meal.fareDetails?.totalFare || 0)}
                            </span>
                            {meal.fareDetails?.discount > 0 && (
                              <>
                                <span className="text-xs text-gray-500 line-through">
                                  AED{formatCurrency(meal.fareDetails?.strikeOff || 0)}
                                </span>
                                <span className="bg-red-100 text-red-600 px-1.5 py-0.5 rounded text-xs font-medium">
                                  -{meal.fareDetails.discount}% OFF
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
            <ShoppingBag className="w-12 h-12 text-gray-400 mx-auto" />
            <p className="text-gray-500 mt-3">Your cart is empty. Add some delicious meals!</p>
          </div>
        )}

        {/* Add-Ons Section */}
        {selectedAddOns.length > 0 && (
          <div className="mt-8">
            <h3 className="text-xl font-semibold flex items-center mb-3 text-gray-800">
              <Plus className="w-5 h-5 mr-2 text-green-600" />
              Enhancements
            </h3>
            <div className="bg-white rounded-xl p-2 shadow-md border border-gray-100">
              {Object.entries(
                selectedAddOns.reduce((acc, addOn) => {
                  if (!acc[addOn.name]) {
                    acc[addOn.name] = { ...addOn, quantity: 1 };
                  } else {
                    acc[addOn.name].quantity += 1;
                  }
                  return acc;
                }, {})
              ).map(([name, addOn], index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-3 bg-gray-50 rounded-lg my-2 hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-white rounded-lg shadow-sm overflow-hidden flex-shrink-0">
                      <img
                        src={addOn.image}
                        alt={addOn.name || "Add-on"}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/api/placeholder/48/48";
                        }}
                      />
                    </div>
                    <div>
                      <span className="text-gray-800 font-medium">{addOn.name}</span>
                      {addOn.quantity > 1 && (
                        <span className="text-gray-500 text-sm block">Quantity: {addOn.quantity}</span>
                      )}
                    </div>
                  </div>
                  <span className="text-gray-900 font-bold bg-green-100 px-3 py-1 rounded-full">
                    AED{formatCurrency(addOn.pricePerDay * addOn.quantity)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Cool Bag Option */}
        {!isNewOrder && (
          <div className="mt-8 bg-gradient-to-r from-blue-50 to-cyan-50 p-4 rounded-xl shadow-sm border border-blue-100">
            <div className="flex items-center space-x-3">
              <input
                type="checkbox"
                id="coolBag"
                checked={coolBag}
                onChange={() => setCoolBag(!coolBag)}
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label htmlFor="coolBag" className="flex items-center space-x-3 cursor-pointer flex-1">
                <div className="w-12 h-12 bg-white rounded-lg shadow-sm overflow-hidden flex-shrink-0">
                  <img src="/api/placeholder/48/48" alt="Cool Bag" className="w-full h-full object-cover" />
                </div>
                <div>
                  <span className="text-gray-900 font-medium">Add Cool Bag</span>
                  <p className="text-sm text-gray-600">Keep your meals fresh during delivery</p>
                </div>
              </label>
            </div>
          </div>
        )}

        {/* Address Section - Updated to use profileData */}
        <div className="mt-8">
          <h3 className="text-xl font-semibold flex items-center mb-3 text-gray-800">
            <MapPin className="w-5 h-5 mr-2 text-green-600" />
            Delivery Address
          </h3>

          {profileData?.savedAddress && profileData.savedAddress.length > 0 ? (
            <div className="relative">
              {/* Currently selected address */}
              <div
                className="bg-white rounded-xl p-4 shadow-md border border-gray-100 cursor-pointer"
                onClick={toggleAddressSelector}
              >
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-green-600" />
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="text-gray-800 font-medium">
                          {profileData.savedAddress[selectedAddressIndex]?.identifier ||
                            profileData.savedAddress[selectedAddressIndex]?.addressType ||
                            `Address ${selectedAddressIndex + 1}`}
                        </p>
                        <div className="text-gray-600 space-y-1">
                          {profileData.savedAddress[selectedAddressIndex]?.flatNumber && (
                            <p className="text-sm">
                              <span className="font-medium">Flat:</span> {profileData.savedAddress[selectedAddressIndex].flatNumber}
                            </p>
                          )}
                          {profileData.savedAddress[selectedAddressIndex]?.buildingName && (
                            <p className="text-sm">
                              <span className="font-medium">Building:</span> {profileData.savedAddress[selectedAddressIndex].buildingName}
                            </p>
                          )}
                          {profileData.savedAddress[selectedAddressIndex]?.streetName && (
                            <p className="text-sm">
                              <span className="font-medium">Street:</span> {profileData.savedAddress[selectedAddressIndex].streetName}
                            </p>
                          )}
                          {profileData.savedAddress[selectedAddressIndex]?.city && (
                            <p className="text-sm">
                              <span className="font-medium">City:</span> {profileData.savedAddress[selectedAddressIndex].city}
                            </p>
                          )}
                          {profileData.savedAddress[selectedAddressIndex]?.landmark && (
                            <p className="text-sm">
                              <span className="font-medium">Landmark:</span> {profileData.savedAddress[selectedAddressIndex].landmark}
                            </p>
                          )}
                        </div>
                        <p className="text-gray-500 mt-2 text-sm">
                          <span className="font-medium">Phone:</span> {profileData.savedAddress[selectedAddressIndex]?.phoneNumber || 'N/A'}
                        </p>
                      </div>
                      <div className="flex items-center text-green-600">
                        {profileData.savedAddress.length > 1 && (
                          <ChevronDown className={`w-5 h-5 transition-transform ${showAddressSelector ? 'rotate-180' : ''}`} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Address selector dropdown */}
              {showAddressSelector && profileData.savedAddress.length > 1 && (
                <div className="absolute left-0 right-0 mt-2 bg-white rounded-xl shadow-lg border border-gray-200 z-10 max-h-64 overflow-y-auto">
                  {profileData.savedAddress.map((address, index) => (
                    <div
                      key={index}
                      className={`p-3 border-b border-gray-100 last:border-0 cursor-pointer hover:bg-gray-50 transition-colors flex items-start ${index === selectedAddressIndex ? 'bg-green-50' : ''}`}
                      onClick={() => selectAddress(index)}
                    >
                      <div className="w-8 mr-3 flex-shrink-0 flex justify-center">
                        {index === selectedAddressIndex ? (
                          <Check className="w-5 h-5 text-green-600" />
                        ) : (
                          <div className="w-5 h-5"></div>
                        )}
                      </div>
                      <div>
                        <p className="font-medium text-gray-800">
                          {address.identifier || address.addressType || `Address ${index + 1}`}
                        </p>
                        <div className="text-sm text-gray-600 space-y-1">
                          {address?.flatNumber && (
                            <p><span className="font-medium">Flat:</span> {address.flatNumber}</p>
                          )}
                          {address?.buildingName && (
                            <p><span className="font-medium">Building:</span> {address.buildingName}</p>
                          )}
                          {address?.streetName && (
                            <p><span className="font-medium">Street:</span> {address.streetName}</p>
                          )}
                          {address?.city && (
                            <p><span className="font-medium">City:</span> {address.city}</p>
                          )}
                          {address?.landmark && (
                            <p><span className="font-medium">Landmark:</span> {address.landmark}</p>
                          )}
                        </div>
                        <p className="text-sm text-gray-500 mt-1">
                          <span className="font-medium">Phone:</span> {address.phoneNumber || 'N/A'}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div className="text-center p-6 bg-gray-50 rounded-lg border border-dashed border-gray-300">
              <MapPin className="w-12 h-12 text-gray-400 mx-auto" />
              <p className="text-gray-500 mt-3">No saved addresses found. Add a delivery address to continue.</p>
            </div>
          )}
        </div>

        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-700">
                <span className="font-medium">{meals.length}-day package summary:</span> The amount shown includes your {meals.length}-day total package and selected add-ons price.
              </p>
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className="mt-8 bg-white rounded-xl p-4 shadow-md border border-gray-100">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Order Summary</h3>

          <div className="space-y-3">
            <div className="flex justify-between items-center py-2">
              <span className="text-gray-600">Meals Total:</span>
              <span className="font-medium text-gray-800">AED{formatCurrency(fareDetails?.mealsTotalPrice)}</span>
            </div>

            <div className="flex justify-between items-center py-2">
              <span className="text-gray-600">Add-Ons Total:</span>
              <span className="font-medium text-gray-800">AED{formatCurrency(fareDetails?.addOnsTotalPrice)}</span>
            </div>
            <div className="h-px bg-gray-200 my-2"></div>
            <div className="flex justify-between items-center py-3">
              {coolBag === true ? (
                <>
                  <span className="text-lg font-semibold text-gray-800">Delivery Bag:</span>
                  <span className="font-medium text-gray-800">AED {formatCurrency(100)}</span>
                  <span className="text-lg font-semibold text-gray-800">Grand Total:</span>
                  <span className="font-medium text-gray-800">AED {formatCurrency(fareDetails?.totalFare + 100)}</span>
                </>
              ) : (
                <>
                  <span className="text-lg font-semibold text-gray-800">Grand Total:</span>
                  <span className="font-medium text-gray-800">AED {formatCurrency(fareDetails?.totalFare)}</span>
                </>
              )}
            </div>
          </div>
        </div>

        <button
          onClick={handleCompleteOrder}
          className="w-full mt-6 bg-gradient-to-r from-green-600 to-green-500 text-white py-4 rounded-xl font-semibold text-lg hover:from-green-700 hover:to-green-600 transition-all shadow-lg hover:shadow-xl flex items-center justify-center"
        >
          Complete Order
          <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
          </svg>
        </button>
      </div>
    </>
  );
};

export default ProductSummary;